import { createContext } from 'react';

export type ToastTone = 'success' | 'error' | 'info';

export interface ToastApi {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
}

/**
 * Contexto dos avisos.
 *
 * Ele vive em arquivo proprio porque o componente e o gancho precisam do mesmo
 * objeto, e um arquivo que exporta os dois quebra a recarga rapida durante o
 * desenvolvimento.
 */
export const ToastContext = createContext<ToastApi | null>(null);
